import React from 'react'

const Templates: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900">Templates</h1>
      <p className="text-gray-600 mt-2">Página em desenvolvimento</p>
    </div>
  )
}

export default Templates



